import React, { useRef, useState, useMemo } from 'react'
import LocationListpop from './popper'
import { Box, Typography, Tooltip } from '@mui/material'
import _ from 'lodash'
// import  from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
const initialSlotProps = {
    popper: {
        width:500,
        placement: 'bottom',
        offset: [0, 9],
        portalSX: {},
        zINdex: 1500,
        sx: {},
        disablePortal: false,
        cardSX: {}
    },
    textfield: {
        sx: {}
    }
}



const PopperSelector = ({ children, slotProps = initialSlotProps, value = null, width = 100, label = null,open=false,setOpen=null,disabled=false,icon=null,tooltipText='' }) => {
    const mergedSlotProps =useMemo(()=>({popper:{...initialSlotProps.popper,...slotProps.popper},textfield:{...initialSlotProps.textfield,...slotProps.textfield}}),[slotProps]) ;
    const [openPoppermodal, setOpenPopperModal] = useState(false)
    const anchorRef = useRef(null)
    const openPopper=useMemo(()=>open?open:openPoppermodal,[openPoppermodal,open])
    const setOpenPopper=useMemo(()=>setOpen?setOpen:setOpenPopperModal,[setOpen])
    const handleOpenPopper = () => {
        setOpenPopper(true)
    }
    const handleClosePopper = () => {
        setOpenPopper(false)
    }
    return (
        <div  aria-label='popper-selector' style={{display:mergedSlotProps.textfield.sx?.flexGrow?'flex':'block'}}>
            <Tooltip title={tooltipText} arrow disableInteractive>
            <Box
            ref={anchorRef}
                sx={{
                    height: "40px",
                    backgroundColor: (theme) => theme.palette.background.paper,
                    opacity: disabled?0.6:1,
                    border: (theme) => `1px solid #D0D5DD`,
                    borderRadius: "8px",
                    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                    position: "relative",
                    px:2,
                    py:1,
                    paddingRight: "10px",
                    color: (theme) => theme.palette.text.secondary,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    transition: "all 0.3s ease-in-out",
                    width: width,

                    "&:hover": {
                        borderColor: (theme) =>disabled?`1px solid #D0D5DD`: theme.palette.primary.light,
                    },

                    cursor:disabled?'auto':"pointer",
                    ...mergedSlotProps.textfield.sx,
                }}
                onClick={() => {
                    if(disabled)return
                    setOpenPopper(true);
                }}
            >
                {value ? (
                    <Typography
                        sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                           
                        }}
                    >
                        {value}
                    </Typography>
                ):<Box/>}
                {label && (
                    <Typography
                        sx={{
                            bgcolor:value?'background.paper':'none',
                            px:value?0.5:0,
                            position: "absolute",
                            top: value ? 9 : "50%",
                            left: theme => value?10:theme.spacing(2),
                            fontSize: value ? "0.7rem" : "0.875rem", // Shrinks when value is present
                            color: (theme) =>value?theme.palette.text.secondary:theme.palette.text.disabled,
                            transform: value ? "translateY(-100%)" : "translateY(-50%)",
                            transition: "all 0.2s ease-in-out",
                            pointerEvents: "none", // Mimics the non-interactive nature of a label
                        }}
                    >
                        {label}
                    </Typography>
                )}
                {icon?icon:<KeyboardArrowDownIcon />}
            </Box>
            </Tooltip>

            <LocationListpop
                border={true}
                open={openPopper}
                handleClose={handleClosePopper}
                anchorRef={anchorRef}
                width={mergedSlotProps.popper.width}
                {...mergedSlotProps.popper}>
                    {children}
                    </LocationListpop>
        </div>
    )
}

export default PopperSelector